import axios, { AxiosError } from 'axios';

import {
  axiosInstance,
  axiosInstanceWithSlug,
} from '../assets/utils/axiosInstance';

interface ErrorResponse {
  message: string;
}

const authService = {
  // Login
  login: async (username?: string, password?: string, key?: string) => {
    // Username and Password Combination Login
    if (username && password) {
      try {
        const response = await axiosInstance().post('/login', {
          username: username,
          password: password,
          is_http_cookie_only: true,
        });
        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        throw axiosError;
      }
    } else if (key) {
      // Key Login
      try {
        const response = await axiosInstance().post('/login/reference-key', {
          reference_key: key,
          is_http_cookie_only: true,
        });
        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        throw axiosError;
      }
    }

    // Error Handling for require username&password or key
    // throw new Error('Username/Email and Password or key required');
  },

  // Login TOTP
  loginTotp: async (ephemeralToken: string, totpCode: string) => {
    // Customer Ephemeral Code and OTP code recieve in users email
    try {
      const response = await axiosInstance().post('/login/code', {
        ephemeral_token: ephemeralToken,
        code: totpCode,
        is_http_cookie_only: true,
      });
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      throw axiosError;
    }
  },

  // Logout
  logout: async () => {
    try {
      const response = await axiosInstance().post('/logout', { is_http_cookie_only:true });
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      throw axiosError;
    }
  },

  // Register
  register: async (email?: string, password?: string, id?: string) => {
    if (!email && !password) {
      try {
        const response = await axiosInstance().post('/register', {
          report: id,
          is_http_cookie_only:true,
        });
        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        throw axiosError;
      }
    } else if (email && password && !id) {
      try {
        const response = await axiosInstance().post('/register', {
          username: email,
          password: password,
          is_http_cookie_only:true,
        });
        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        throw axiosError;
      }
    } else {
      try {
        const response = await axiosInstance().post('/register', {
          username: email,
          password: password,
          report: id,
        });
        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        throw axiosError;
      }
    }
  },

  refreshAccessToken: async () => {
    const API_PATH = import.meta.env.VITE_API_PATH ?? '';
    const HTTPS_PROTOCOL = import.meta.env.VITE_HTTPS_PROTOCOL;
    try {
      const response = await axios.post(`${HTTPS_PROTOCOL}${API_PATH}/token/refresh`, {
        is_http_cookie_only: true,
      },
      { withCredentials: true });
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      throw axiosError;
    }
  },

  // Generate Access Key for overview page registration
  generatePrivateKey: async () => {
    try {
      const response = await axiosInstance().get('/private-key');
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      return axiosError;
    }
  },

  // Register using generated private key
  registerViaPrivateKey: async (privateKey : string) => {
    try {
      const response = await axiosInstanceWithSlug().post('/register/private-key', {
        private_key:privateKey,
        is_http_cookie_only:true,
      });
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      return axiosError;
    }
  },
  //Get Flags for Whistleblower user
  getUserFlags: async () => {
    try {
      const response = await axiosInstance().get('/flags');
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      throw axiosError;
    }
  },
};

export default authService;
